import { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate, formatDateReverse, useStateDistrict } from "../../utils/Utilities.js";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./CreateEmployee.css";
import TopBar from "./TopBar";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import useAuth from "../../hooks/useAuth";
const GET_FRANCHISE_URL = "api/get-franchise";


const UpdateFranchise = () => {

    const { auth } = useAuth();
    const [showValidation, setShowValidation] = useState(false);
    const [selectedParentName_Code, setSelectedParentName_Code] = useState("");
    const [filteredFranchises, setFilteredFranchises] = useState([]);
    const debounceRef = useRef(null);
    const [selectedParentFranchise_id, setSelectedParentFranchise_id] = useState("");
    const [parentfranchiseCode, setParentFranchiseCode] = useState("");
    const [selectedFranchise, setSelectedFranchise] = useState(null);
    const [parentFranchiseId, setParentFranchiseId] = useState("");

    const [businesstypes, setBusinesstypes] = useState([]);
    const [selectedBusinesstype, setSelectedBusinesstype] = useState("");
    const [selectedParentBusinesstype, setSelectedParentBusinesstype] = useState("");
    // const [frCreationType, setFrCreationType] = useState("UnderAnother")
    const [frCreationType, setFrCreationType] = useState("Direct");

    const {
        statesList,
        districtsList,
        stateId,
        setStateId,
        district,
        setDistrict,
        loadingStates,
        loadingDistricts,
    } = useStateDistrict();

    const navigate = useNavigate();
    const handleRedirect = () => {
        navigate("/listfranchises");
    }

    // Initialize state for firstTabInput to store form data
    // const [firstTabInput, setFirstTabInput] = useState(""); 
    const { franchiseId } = useParams(); // Get the franchiseId from the URL
    const [franchise, setFranchise] = useState([]); // To store list of users

    const [franchiseName, setFranchiseName] = useState("");
    const [franchiseCode, setFranchiseCode] = useState("");
    const [businessType, setBusinessType] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [address, setAddress] = useState("");
    const [contractDate, setContractDate] = useState("");
    const [place, setPlace] = useState("");
    const [city, setcity] = useState("");
    const [pincode, setpincode] = useState("");
    const [state, setState] = useState("");
    const [mobile, setMobile] = useState("");
    const [landPhone, setLandPhone] = useState("");
    const [email, setemail] = useState("");
    const [gstNumber, setGstNumber] = useState("");
    const [panNumber, setPanNumber] = useState("");
    const [remarks, setRemarks] = useState("");
    const [serviceAreas, setServiceAreas] = useState("");

    const axiosPrivate = useAxiosPrivate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [searchLoading, setSearchLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showValidation2, setShowValidation2] = useState(false);




    useEffect(() => {
        if (auth.franchise_id === null) {
            if (parentFranchiseId) {
                setFrCreationType("UnderAnother");
            } else {
                setFrCreationType("Direct");
            }
        } else {
            setFrCreationType("Direct");
        }
    }, [auth.franchise_id, parentFranchiseId]);

    const fetchFranchises = async (searchValue, businessType) => {
        try {
            if (!businessType || !searchValue.trim()) {
                setFilteredFranchises([]);
                return;
            }

            setSearchLoading(true);

            const response = await axiosPrivate.get(
                `/api/list-franchises-by-type`,
                {
                    params: {
                        business_type: businessType,
                        search_text: searchValue,
                    },
                    withCredentials: true,
                }
            );

            setFilteredFranchises(response.data || []);
        } catch (error) {
            console.error("Error fetching franchises:", error);
            setFilteredFranchises([]);
        } finally {
            setSearchLoading(false);
        }
    };

    const franchiseHandleSelect = (franchise) => {
        setSelectedParentName_Code(
            `${franchise.franchise_name} (${franchise.franchise_code})`
        );

        setSelectedParentFranchise_id(franchise.franchise_id);

        setParentFranchiseCode(franchise.franchise_code);
        setSelectedFranchise(franchise);
        setFilteredFranchises([]);
    };


    const handleInputChange = (e) => {
        const value = e.target.value;
        setSelectedParentName_Code(value);

        // Clear dropdown if input is empty
        if (!value.trim()) {
            setFilteredFranchises([]);
            return;
        }

        // Debounce API call
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            fetchFranchises(value, selectedParentBusinesstype);
        }, 400);
    };

    useEffect(() => {
        const fetchBusinesstypes = async () => {
            try {
                let excludeTypes = [];

                if (auth?.business_type === "MBA") {
                    excludeTypes = ["MBA"];
                } else if (auth?.business_type === "RO") {
                    excludeTypes = ["MBA", "RO"];
                } else if (auth?.business_type === "BA") {
                    excludeTypes = ["MBA", "RO", "BA"];
                }

                const query =
                    excludeTypes.length > 0
                        ? `?exclude_types=${excludeTypes.join(",")}`
                        : "";

                const res = await axiosPrivate.get(
                    `/api/list-businesstypes${query}`
                );

                // ❌ Remove Head Office (HO)
                const filtered = res.data.filter(
                    (item) => item.value !== "HO"
                );

                setBusinesstypes(filtered);
            } catch (error) {
                console.error("Failed to load businesstypes", error);
            }
        };

        fetchBusinesstypes();
    }, [auth?.business_type]);

    useEffect(() => {
        const fetchData = async () => {
            const headers = {
                "Content-Type": "application/json",
            };
            const data = {
                // manifest_number: manifestNumber,
                franchise_id: franchiseId,
            };
            try {

                const response = await axiosPrivate.get(GET_FRANCHISE_URL, {
                    params: data,
                    headers,
                    withCredentials: true, // Ensures cookies are sent with the request if needed
                });

                setFranchise(response.data); // Store the fetched data into the user state
                setFranchiseName(response.data.franchise_name);
                // setFranchiseCode(response.data.franchise_code);
                setFranchiseCode(response.data.franchise_code.slice(6));

                setSelectedBusinesstype(response.data.business_type);
                setContactPerson(response.data.contact_person);
                setAddress(response.data.address);

                const formatDate_Reverse = formatDateReverse(response.data.contract_date);
                setContractDate(formatDate_Reverse);
                setPlace(response.data.place);
                setcity(response.data.city);
                setStateId(response.data.state_id);
                setDistrict(response.data.district_id);
                setpincode(response.data.pincode);
                setMobile(response.data.mobile);
                setLandPhone(response.data.land_phone);
                setemail(response.data.email);
                setGstNumber(response.data.gst_number);
                setPanNumber(response.data.pan_number);
                setRemarks(response.data.remarks);
                setServiceAreas(response.data.service_areas);
                setParentFranchiseId(response.data.parent_franchise_id);
                setSelectedParentBusinesstype(response.data.parent_business_type)
                // setSelectedParentName_Code(
                //     `${response.data.parent_franchise_name} (${response.data.parent_franchise_code})`
                // );
                setSelectedParentName_Code(
                    response.data.parent_franchise_name &&
                        response.data.parent_franchise_code
                        ? `${response.data.parent_franchise_name} (${response.data.parent_franchise_code})`
                        : ""
                );

                setPageLoading(false); // Stop loading spinner
            } catch (error) {
                console.error("Error fetching data:", error);
                setError("Failed to load data");
                setPageLoading(false); // Set loading to false even if there is an error
            }
        };

        fetchData();
    }, []);

    if (pageLoading) {
        return <div className="loading">Loading...</div>;
    }

    if (error) {
        return <div className="error">{error}</div>;
    }

    // Handle form completion
    const handleComplete = async () => {
        setIsSubmitting(true);

        let parent_franchise_id = null;

        // ✅ Franchise login user → always use own franchise id
        if (auth?.business_type != null && auth?.franchise_id) {
            parent_franchise_id = auth.franchise_id;
        }

        // ✅ HO user
        else {
            // Under Another Fr.
            if (
                frCreationType === "UnderAnother" &&
                selectedParentFranchise_id
            ) {
                parent_franchise_id = selectedParentFranchise_id;
            }

            // Direct Franchise
            else if (frCreationType === "Direct") {
                parent_franchise_id = null;
            }
        }

        // Collect form data
        const formData = {
            franchise_id: franchiseId,
            franchise_name: franchiseName,
            contract_date: contractDate,
            franchise_code: fullCode,

            mobile,
            land_phone: landPhone,
            email,
            address,
            city,
            place,
            pincode,
            state: stateId,
            district_id: district,
            contact_person: contactPerson,
            business_type: selectedBusinesstype,
            gst_number: gstNumber,
            pan_number: panNumber,
            remarks,

            parent_franchise_id,
        };



        try {
            // Format date before sending
            const formattedDate = formatDate(contractDate);

            // Prepare payload
            const data = JSON.stringify({
                ...formData,
                contract_date: formattedDate, // Rename date for backend consistency
            });

            console.log("Payload Data:", data);

            // Make POST request
            const response = await axiosPrivate.post(UPDATE_FRANCHISE_URL, data, {
                headers: { "Content-Type": "application/json" },
                withCredentials: true, // Ensure cookies are sent
            });

            console.log("Registration successful:", response.data);

            alert("Franchise Updated successfully!"); // Notify the user

            // submitForm(); // Proceed with any additional form submission logic
        } catch (error) {
            console.error("Error submitting form data:", error);
            alert("An error occurred while submitting your data. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // Validate first tab input
    const checkValidateTab = () => {
        if (
            franchiseName === "" ||
            franchiseCode === "" ||
            selectedBusinesstype === "" ||
            contactPerson === "" ||
            address === "" ||
            place === "" ||
            city === "" ||
            pincode === "" ||
            stateId === "" ||
            mobile === "" ||
            district === ""
        ) {
            return false;
        }

        // ✅ Parent Franchise fields mandatory only for "Under Another Fr."
        if (
            frCreationType === "UnderAnother" &&
            (
                selectedParentBusinesstype === "" ||
                selectedParentName_Code === ""
            )
        ) {
            return false;
        }

        return true;
    };

    // Validate second tab input
    const checkValidateTab2 = () => {
        if (email === "" || contractDate === "") {
            return false;
        }
        return true; // Both fields are not empty
    };

    // Error messages for validation
    const errorMessages = () => {
        setShowValidation(true); // Triggers inline messages
        // alert("Please fill in the required fields");
    };


    const errorMessages2 = () => {
        setShowValidation2(true); // Triggers inline messages
        // alert("Please fill in the required fields");
    };

    const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
    const EMAIL_REGEX =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const NAME_REGEX = /^(?!\s*$).+/;
    const UPDATE_FRANCHISE_URL = "api/update-franchise";


    // helper function or derived value from selectedDistrict
    const selectedDistrict = districtsList.find(
        (d) => d.district_id === Number(district)
    );

    const selectedDistrictName = selectedDistrict?.district_name || "";

    // helper function or Derive the selected state object selectedState
    const selectedState = statesList.find(
        (s) => s.state_id === Number(stateId)
    );

    const selectedStateName = selectedState?.state_name || "";
    const districtCode = selectedDistrict?.district_code || "";


    const fullCode = `${districtCode}-${franchiseCode}`;


    return (
        <>
            <section className="franchbody">
                <div className="wrapper10">
                    <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">Franchise list</button>
                    <center><h2 className="mul_head">Edit Franchise </h2></center>


                    <FormWizard onComplete={handleComplete}>
                        <FormWizard.TabContent title="Basic Info" icon="ti-user">
                            {/* <h3>Basic Information</h3> */}
                            {/* <p>Some content for the first tab</p> */}
                            <div className=" input-boxnew">
                                <Row>
                                    {/* Radio Button Section */}
                                    <Col>
                                        <div className="input-boxx">
                                            <label>
                                                Fr. Creation Type<sup>*</sup>
                                            </label>

                                            <div className="customer-type-wrapper">
                                                <Form.Check
                                                    type="radio"
                                                    id="directFranchise"
                                                    label="Direct Franchise"
                                                    name="FrCreationType"
                                                    value="Direct"
                                                    checked={frCreationType === "Direct"}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        setFrCreationType(value);

                                                        // Clear parent franchise data when switching to Direct
                                                        if (value === "Direct") {
                                                            setSelectedParentName_Code("");
                                                            setSelectedParentBusinesstype("");
                                                            setFilteredFranchises([]);
                                                            setSelectedParentFranchise_id("");
                                                            setParentFranchiseCode("");
                                                            setSelectedFranchise(null);
                                                        }
                                                    }}
                                                    className="newput"
                                                />
                                                {auth?.business_type == null && (
                                                    <Form.Check
                                                        type="radio"
                                                        id="underAnotherFr"
                                                        label="Under Another Fr."
                                                        name="FrCreationType"
                                                        value="UnderAnother"
                                                        checked={frCreationType === "UnderAnother"}
                                                        onChange={(e) => setFrCreationType(e.target.value)}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                {frCreationType === "UnderAnother" && (
                                    <Row>
                                        <Col>
                                            <div className="input-boxs">
                                                <label htmlFor="businessType">
                                                    Parent Fr. Type<sup>*</sup>
                                                </label>

                                                <select
                                                    className="newregselect"
                                                    value={selectedParentBusinesstype}
                                                    onChange={(e) => {
                                                        setSelectedParentBusinesstype(e.target.value);
                                                        setSelectedParentName_Code("");
                                                        setFilteredFranchises([]);
                                                    }}
                                                >
                                                    <option value="">Select Business Type</option>

                                                    {businesstypes
                                                        .filter((businesstype) => businesstype.value !== "CC")
                                                        .map((businesstype) => (
                                                            <option
                                                                key={businesstype.value}
                                                                value={businesstype.value}
                                                            >
                                                                {businesstype.text} ({businesstype.value})
                                                            </option>
                                                        ))}
                                                </select>

                                                {showValidation && !selectedParentBusinesstype && (
                                                    <div className="mt-1 reqstyl">
                                                        *Parent Franchise Type is required
                                                    </div>
                                                )}
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="input-boxs">
                                                <label htmlFor="FranchiseName">
                                                    Parent Fr. Name or Code<sup>*</sup>
                                                </label>

                                                <input
                                                    type="text"
                                                    id="franchise-name"
                                                    autoComplete="off"
                                                    placeholder="Search Franchise Name or Code"
                                                    onChange={handleInputChange}
                                                    value={selectedParentName_Code}
                                                    disabled={!selectedParentBusinesstype}
                                                    style={{
                                                        ...styles.input,
                                                        backgroundColor: !selectedParentBusinesstype
                                                            ? "#e9ecef"
                                                            : "#fff",
                                                        cursor: !selectedParentBusinesstype
                                                            ? "not-allowed"
                                                            : "text",
                                                    }}
                                                />

                                                {searchLoading && selectedParentName_Code.trim() && (
                                                    <div className="loader">Searching...</div>
                                                )}

                                                {selectedParentName_Code &&
                                                    filteredFranchises.length > 0 && (
                                                        <ul style={styles.dropdown}>
                                                            {filteredFranchises.map((franchise) => (
                                                                <li
                                                                    key={franchise.franchise_id}
                                                                    style={styles.dropdownItem}
                                                                    onMouseDown={() =>
                                                                        franchiseHandleSelect(franchise)
                                                                    }
                                                                >
                                                                    {franchise.franchise_name} (
                                                                    {franchise.franchise_code})
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                {showValidation && !selectedParentName_Code && (
                                                    <div className="mt-1 reqstyl">*Parent Fr. is required</div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                                <Row>
                                    <Col>
                                        <div className="input-boxs">
                                            <label>State<sup>*</sup></label>
                                            <select className="newregselect"
                                                value={stateId} onChange={(e) => setStateId(e.target.value)} >
                                                <option value="">Select State</option>
                                                {statesList.map((state) => (
                                                    <option key={state.state_id}
                                                        value={state.state_id}>
                                                        {state.state_name} - ({state.state_code})
                                                    </option>))}
                                            </select>
                                            {showValidation && !stateId && (
                                                <div className="mt-1 reqstyl">*State is required</div>
                                            )}
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="input-boxs">
                                            <label>District<sup>*</sup></label>
                                            <select className="newregselect"
                                                value={district}
                                                onChange={(e) => setDistrict(e.target.value)}
                                                disabled={!stateId}
                                            >
                                                <option value="">Select District</option>
                                                {districtsList.map((dist) => (
                                                    <option key={dist.district_id}
                                                        value={dist.district_id}>
                                                        {dist.district_name} - ({dist.district_code})
                                                    </option>))}
                                            </select>
                                            {showValidation && !district && (
                                                <div className="mt-1 reqstyl">*District is required</div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className=" input-boxs">
                                            <label htmlFor="franchiseName">Franchise Name<sup>*</sup></label>


                                            <input
                                                type="text"
                                                className="form-control"
                                                value={franchiseName}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const formatted =
                                                        value.charAt(0).toUpperCase() + value.slice(1);
                                                    setFranchiseName(formatted);
                                                }}
                                            />

                                            {showValidation && !franchiseName && (
                                                <div className="mt-1 reqstyl"> * Name is required</div>
                                            )}


                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="input-boxs">
                                            <label>
                                                Franchise Code<sup>*</sup>
                                                {/* {districtCode && (
                                                    <small className="text-muted">
                                                    (Prefix from district: {districtCode})
                                                    </small>
                                                )} */}
                                            </label>
                                            <div className="input-group">
                                                <span className="input-group-text fw-bold" style={{ color: '#6c757d' }}>
                                                    {districtCode}
                                                </span>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={
                                                        selectedDistrict
                                                            ? "Enter remaining code"
                                                            : "Select district first"
                                                    }
                                                    value={franchiseCode}
                                                    onChange={(e) =>
                                                        setFranchiseCode(
                                                            e.target.value.toUpperCase().slice(0, 5)
                                                        )
                                                    }
                                                    disabled={!selectedDistrict}
                                                    maxLength={5}
                                                />
                                            </div>

                                            {showValidation && !franchiseCode && (
                                                <div className="mt-1 reqstyl">
                                                    *Remaining code is required
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className=" input-boxs">
                                            <label htmlFor="businessType">Business Type<sup>*</sup></label>

                                            <select
                                                className="newregselect"
                                                value={selectedBusinesstype}
                                                onChange={(e) => setSelectedBusinesstype(e.target.value)}
                                            >
                                                <option value="">Select Business Type</option>

                                                {businesstypes.map((businesstype) => (
                                                    <option key={businesstype.value} value={businesstype.value}>
                                                        {businesstype.text} ({businesstype.value})
                                                    </option>
                                                ))}
                                            </select>

                                            {showValidation && !selectedBusinesstype && (
                                                <div className="mt-1 reqstyl"> *BusinessType is required</div>
                                            )}


                                        </div>
                                    </Col>
                                    <Col>
                                        <div className=" input-boxs">
                                            <label htmlFor="contactPerson">Contact Person<sup>*</sup></label>


                                            <input
                                                type="text"
                                                className="form-control"
                                                value={contactPerson}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setContactPerson(
                                                        value.charAt(0).toUpperCase() + value.slice(1)
                                                    );
                                                }}
                                            />

                                            {showValidation && !contactPerson && (
                                                <div className="mt-1 reqstyl"> *Contact Person is required</div>
                                            )}


                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className=" input-boxs">
                                            <label htmlFor="address">Address<sup>*</sup>
                                            </label>


                                            <input
                                                type="text"
                                                className="form-control"
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)}

                                            />
                                            {showValidation && !address && (
                                                <div className="mt-1 reqstyl"> *Address is required</div>
                                            )}


                                        </div>
                                    </Col>
                                    <Col>
                                        <div className=" input-boxs">
                                            <label htmlFor="place">Place<sup>*</sup>
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={place}
                                                onChange={(e) => setPlace(e.target.value)}

                                            />
                                            {showValidation && !place && (
                                                <div className="mt-1 reqstyl"> *Place is required</div>
                                            )}

                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>

                                        <div className=" input-boxs">
                                            <label htmlFor="city">City<sup>*</sup>
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={city}
                                                onChange={(e) => setcity(e.target.value)}
                                            />
                                            {showValidation && !city && (
                                                <div className="mt-1 reqstyl"> *City is required</div>
                                            )}


                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="input-boxs">
                                            <label htmlFor="pincode">
                                                Pincode<sup>*</sup>
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={pincode}
                                                maxLength={6}                 // ✅ restricts to 6 characters
                                                inputMode="numeric"
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, ""); // ✅ only digits
                                                    setpincode(value);
                                                }}
                                            />

                                            {showValidation && !pincode && (
                                                <div className="mt-1 reqstyl">*Pincode is required</div>
                                            )}

                                            {pincode && pincode.length < 6 && (
                                                <div className="mt-1 reqstyl">
                                                    *Pincode must be exactly 6 digits
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="input-boxs">
                                            <label htmlFor="mobile1">
                                                Mobile<sup>*</sup>
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={mobile}
                                                maxLength={10}                     // ✅ max 10 digits
                                                inputMode="numeric"                // ✅ mobile-friendly keypad
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, ""); // ✅ digits only
                                                    setMobile(value);
                                                }}
                                            />

                                            {showValidation && !mobile && (
                                                <div className="mt-1 reqstyl">*Mobile is required</div>
                                            )}

                                            {mobile && mobile.length < 10 && (
                                                <div className="mt-1 reqstyl">
                                                    *Mobile number must be 10 digits
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </FormWizard.TabContent>

                        <FormWizard.TabContent
                            title="Additional Info"
                            icon="ti-settings"
                            isValid={checkValidateTab()} // Validate based on first tab input
                            validationError={errorMessages} // Show validation error if invalid
                        >
                            {/* <h3>Additional Information</h3> */}
                            <Row>
                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="landPhone">LandPhone</label>

                                        <input type="text"
                                            className="form-control"
                                            value={landPhone}
                                            onChange={(e) => setLandPhone(e.target.value)}
                                        />


                                    </div>
                                </Col>
                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="email">Email<sup>*</sup></label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setemail(e.target.value)}
                                        />
                                        {showValidation2 && !email && (
                                            <div className="mt-1 reqstyl"> *Email is required</div>
                                        )}

                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="gstNumber">Gst Number</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={gstNumber}
                                            onChange={(e) => setGstNumber(e.target.value)}
                                        />


                                    </div>
                                </Col>
                                <Col>


                                    <div className=" input-boxs">
                                        <label htmlFor="panNumber">PAN Number</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={panNumber}
                                            onChange={(e) => setPanNumber(e.target.value)}
                                        />
                                        {/* <i className="bx bxs-user"></i> */}


                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="contractDate"> Contract Date<sup>*</sup></label>

                                        <input
                                            type="date"
                                            className="form-control newregselect"
                                            value={contractDate}
                                            onChange={(e) => setContractDate(e.target.value)}
                                            style={{ fontSize: "15px" }}
                                        />
                                        {showValidation2 && !contractDate && (
                                            <div className="mt-1 reqstyl"> *Date is required</div>
                                        )}


                                    </div>
                                </Col>
                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="remarks">Remarks  </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={remarks}
                                            onChange={(e) => setRemarks(e.target.value)}
                                        />
                                        {/* {showValidation2 && !remarks && (
                      <div className="mt-1 reqstyl"> *Remarks is required</div>
                    )} */}


                                    </div>
                                </Col>
                            </Row>
                        </FormWizard.TabContent>

                        <FormWizard.TabContent title="Review & Submit" icon="ti-check"
                            isValid={checkValidateTab2()} // Validate based on first tab input
                            validationError={errorMessages} // Show validation error if invalid
                        >
                            {/* <h3>Review Details</h3> */}
                            {/* <p>Here is a summary of your details:</p> */}

                            <Row>
                                <Col>
                                    <p className="multip">
                                        <span className="empspan">Fr. Creation Type :</span>{" "}

                                        {frCreationType === "Direct"
                                            ? "Direct Franchise"
                                            : frCreationType === "UnderAnother"
                                                ? "Under Another Fr."
                                                : ""}
                                    </p>
                                </Col>

                                <Col>
                                    {frCreationType === "UnderAnother" && (
                                        <p className="multip"><span className="empspan">Parent Fr. :</span>{selectedParentBusinesstype} - {selectedParentName_Code}</p>
                                    )}
                                </Col>

                            </Row>
                            <Row>
                                <Col><p className="multip"><span className="empspan">Franchise Name :</span> {franchiseName}</p> </Col>
                                <Col><p className="multip"><span className="empspan">Franchise Code :</span> {fullCode}</p></Col>
                            </Row>

                            <Row>
                                <Col><p className="multip"><span className="empspan">Business Type :</span> {selectedBusinesstype} </p></Col>
                                <Col><p className="multip"><span className="empspan">Contact Person :</span> {contactPerson}</p> </Col>
                            </Row>

                            <Row>
                                <Col><p className="multip"><span className="empspan">Place :</span> {place}</p> </Col>
                                <Col><p className="multip"><span className="empspan">State and District :</span> {selectedStateName || "—"}, {selectedDistrictName || "—"}</p></Col>
                            </Row>
                            <Row>
                                <Col><p className="multip"><span className="empspan">City :</span> {city}</p></Col>
                                <Col><p className="multip"><span className="empspan">Pincode :</span> {pincode}</p></Col>
                            </Row>

                            <Row>
                                <Col><p className="multip"><span className="empspan">Address :</span> {address}</p></Col>
                                <Col><p className="multip"><span className="empspan">Mobile :</span> {mobile}</p></Col>
                            </Row>
                            <Row>
                                <Col><p className="multip"><span className="empspan">LandPhone :</span> {landPhone}</p></Col>
                                <Col><p className="multip"><span className="empspan">Email :</span> {email}</p></Col>
                            </Row>

                            <Row>
                                <Col><p className="multip"><span className="empspan">GST Number :</span> {gstNumber}</p></Col>
                                <Col><p className="multip"><span className="empspan">PAN Number :</span> {panNumber}</p></Col>
                            </Row>

                            <Row>
                                <Col><p className="multip"><span className="empspan">Contract Date :</span> {contractDate}</p></Col>
                                <Col><p className="multip"><span className="empspan">Remarks :</span> {remarks}</p></Col>
                            </Row>

                        </FormWizard.TabContent>
                    </FormWizard>

                </div>
            </section >
            <TopBar />
        </>
    );


};
const styles = {
    container: {
        padding: '40px',
        maxWidth: '500px',
        margin: 'auto',
        fontFamily: 'Arial, sans-serif',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    inputWrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    input: {
        padding: '10px',
        fontSize: '16px',
        border: '1px solid #ccc',
        borderRadius: '4px',
    },
    dropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderTop: 'none',
        maxHeight: '200px',
        overflowY: 'auto',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee',
    },
    button: {
        padding: '10px 15px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        cursor: 'pointer',
    },


};

export default UpdateFranchise;